export const typography = {
  fontFamily: "Poppins",
};

export const variants = [
  {
    props: { variant: "Page Title" },
    style: ({ theme }) => ({ fontSize: "30px", fontWeight: 500, color: theme.palette.text.main, textAlign: "left" }),
  },
  {
    props: { variant: "Page Subtitle" },
    style: ({ theme }) => ({ fontSize: "15px", fontWeight: 100, color: theme.palette.text.secondary, textAlign: "left" }),
  },
  {
    props: { variant: "Card Title" },
    style: ({ theme }) => ({ fontSize: "18px", fontWeight: 600, color: theme.palette.text.main, textAlign: "left" }),
  },
  {
    props: { variant: "Card Subtitle" },
    style: ({ theme }) => ({ fontSize: "13px", fontWeight: 400, color: theme.palette.text.secondary, textAlign: "left" }),
  },
  {
    props: { variant: "Card Title 2" },
    style: ({ theme }) => ({ fontSize: "17px", fontWeight: 500, color: theme.palette.text.main, textAlign: "left" }),
  },
  {
    props: { variant: "Card Main Content 2" },
    style: ({ theme }) => ({ fontSize: "28px", fontWeight: 600 }),
  },
  {
    props: { variant: "Card Subtitle 2" },
    style: ({ theme }) => ({ fontSize: "14px", color: theme.palette.text.secondary }),
  },
  {
    props: { variant: "Navigation" },
    style: ({ theme }) => ({ fontSize: "16px", fontWeight: 400, color: theme.palette.text.main }),
  },
  {
    props: { variant: "Table Sub Title" },
    style: ({ theme }) => ({ fontSize: "14px", fontWeight: 400, color: theme.palette.text.table_sub_title }),
  },
  {
    props: { variant: "Chart Title" },
    style: ({ theme }) => ({
      fontSize: "20px",
      fontWeight: 500,
      color: theme.palette.text.main,
      display: "flex",
      alignItems: "center",
    }),
  },
  {
    props: { variant: "Grid Header" },
    style: ({ theme }) => ({ fontSize: "14px", fontWeight: 500, color: theme.palette.text.grid_header }),
  },
  {
    props: { variant: "Sidebar Header Level 1" },
    style: ({ theme }) => ({ fontSize: "20px", fontWeight: 500, color: theme.palette.text.sidebar_header_level_1, textAlign: "left", textWrap: "nowrap" }),
  },
  {
    props: { variant: "Sidebar Header Level 2" },
    style: ({ theme }) => ({ fontSize: "20px", fontWeight: 500, color: theme.palette.text.sidebar_header_level_2, textAlign: "left", textWrap: "nowrap" }),
  },
  {
    props: { variant: "Sidebar List Item" },
    style: ({ theme }) => ({ fontSize: "16px", fontWeight: 400, textAlign: "left", textWrap: "nowrap" }),
  },
  {
    props: { variant: "Accordion Summary" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "18px",
      fontWeight: 500,
      width: "100%",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      textAlign: "left",
      color: theme.palette.text.main,
      whiteSpace: "nowrap",
      "&:hover": { color: theme.palette.text.main_hover },
    }),
  },
  {
    props: { variant: "Table Title" },
    style: ({ theme }) => ({
      color: theme.palette.text.table_title,
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: "20px",
      textAlign: "left",
      display: "flex",
      alignItems: "center",
    }),
  },
  {
    props: { variant: "List Title" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      color: theme.palette.text.main,
      textAlign: "left",
    }),
  },
  {
    props: { variant: "Dialog Title" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "24px",
      color: theme.palette.text.main,
      textWrap: "nowrap",
      textAlign: "left",
    }),
  },
  {
    props: { variant: "Dialog Content" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.main,
      fontSize: "20px",
      textWrap: "nowrap",
      textAlign: "left",
    }),
  },
  {
    props: { variant: "Header Username" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "22px",
      fontWeight: 800,
      color: theme.palette.text.main,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    }),
  },
  {
    props: { variant: "Textbox Label" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.textbox_label,
      textAlign: "left",
    }),
  },
  {
    props: { variant: "Pie Chart Inner Title" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "13px",
      color: theme.palette.text.piechart_inner_title,
      textWrap: "nowrap",
    }),
  },
  {
    props: { variant: "Pie Chart Inner Text" },
    style: ({ theme }) => ({
      fontFamily: theme.typography.fontFamily,
      fontSize: "20px",
      fontWeight: 500,
      color: theme.palette.text.main,
      textWrap: "nowrap",
    }),
  },
];
